import React from 'react';
export const FeatureContext = React.createContext(null);
